import React, {
  ReactNode,
} from 'react';
import {
  flexRender,
  HeaderGroup,
  Header,
} from '@tanstack/react-table';
import clsx from 'clsx';
import {
  getTableColumnProps,
  TABLE_ROW_COMMON_CLASSES,
} from 'core/components/VirtualTable/helpers';
import {
  FooterDef,
} from 'core/components/VirtualTable/types';
import isNil from 'lodash/isNil';

type Props<T> = {
  footerGroups: HeaderGroup<T>[];
  className?: string;
};

function Column<T>({
  column,
  getContext,
}: Header<T, any>) {
  const { footer } = column.columnDef;
  const footerDef = footer as FooterDef<T>;

  const render = !isNil(footerDef?.render)
    ? footerDef?.render
    : footer;

  return (
    <div
      {...getTableColumnProps(
        typeof footer === 'object'
          ? footer
          : column.columnDef,
      )}
    >
      {flexRender(
        render,
        getContext(),
      ) as ReactNode}
    </div>
  );
}
export default function TableFooter<T>({
  footerGroups,
  className,
}: Props<T>) {
  const classes = `
populate-table-row-footer ${TABLE_ROW_COMMON_CLASSES} border-t border-[#dde2ee]
text-xs text-gray-400 font-semibold
`;
  const isWindows = /(win32|win64|windows|wince)/i.test(navigator.userAgent);

  return (
    <div className={clsx(
      'populate-table-footer flex-[0_1_0%]',
      className,
      { '!mr-4': isWindows },
    )}
    >
      {footerGroups.map((group) => {
        const isRenderDefined = group.headers.some(
          (header) => !isNil((header.column.columnDef?.footer as FooterDef<T>)?.render),
        );
        return (
          <div
            key={group.id}
            className={classes}
          >
            {group.headers.map((footer) => (
              isRenderDefined && isNil(footer.column.columnDef?.footer)
                ? null
                : (
                  <Column
                    key={footer.id}
                    {...footer}
                  />
                )))}
          </div>
        );
      })}
    </div>
  );
}
